import {auth,refUsers} from '@/firebaseConfig'
import router from '@/router/index.js';
import CryptoJS from 'crypto-js'

// Restauração da sessão guardada em memória: o main.js dispara antes de montar
// o app e o guard de rota espera a mesma promessa, então a checagem roda uma
// única vez por carregamento, não importa quantos chamem.
let promessaRestauracao = null

export default{
    state: {
        userProfile: null,
        loginError: null,
        loading: false,
        diaAtual: new Date().getDate(),
        userLvl: null,
        //permisao1 = hash md5
        permissoes: {
          '506481A50E6CEDDED6C48B52CAB9A2A9' : 1, // md5 de permissao 1
          '7F2CB9F1C1E54E71000175B5BDD2ADD0' : 2, //permissao 2 // barbeiro
          '5A1017C0D03F3B3A2FC48D30027AA71B' : 3, //permissao 3 // gestor
          '4A3BB12B0552F49A6BE92431FE2A1231' : 4, //permissao 4
          'EB64284B81296A3D0B08D7925A9E09D9' : 5, //permissao 5 // admin sistema
        }
       },
       mutations: { //syncrono
         setUserProfile(state, val) {

           val.uid = CryptoJS.MD5(val.uid + state.diaAtual.toString()).toString();
         

           state.userProfile = {...val};
           state.userLvl = val.lvl;

           console.log("state",state.userProfile);
           console.log("state LVL",state.userLvl);
           
           window.localStorage.setItem("user", JSON.stringify(val));
           
         },
         setError(state, payload){
           state.loginError = payload;
         },
         resetError(state){
           state.loginError = null;
         },
         changeLoading(state, payload){
           state.loading = payload
         },
         logoutUser(state){

            state.userProfile = null;
            window.localStorage.removeItem("user")
            console.log("logout");
            document.location.reload()
         }
       },
       actions: {
        logout({ commit }){
            auth.signOut().then(() => {
                commit('logoutUser')    
              }).catch((error) => {
                console.log("erro", error);
              });
            
            
        },
         login({dispatch}, form){
           this.commit('changeLoading', true);
           auth.signInWithEmailAndPassword(form.email, form.senha).then((user) =>{
             //console.log(user.user);
             this._vm.$toasted.global.defaultSuccess("Login realizado com sucesso!");
     
             dispatch('fetchUserProfile', user.user)
     
         }).catch(err => {
             
           this.commit('setError', err.message);
           this.commit('changeLoading', false);
           console.log(err.message);
           this._vm.$toasted.global.defaultError(err.message)
     
             //this.loading = false;
         });
         },
         async signup({ dispatch, }, form) {
           // sign user up
           auth.createUserWithEmailAndPassword(form.email, form.password).then(ref => {
             const user = ref.user;
              // create user profile object in userCollections
             refUsers.doc(user.uid).set({
             name: form.name,
             email: form.email,
             uid: user.uid,
             lvl: '7F2CB9F1C1E54E71000175B5BDD2ADD0'
           }).then(user => {
             // fetch user profile and set in state
             this._vm.$toasted.global.defaultSuccess("Usuário criado com sucesso!");
     
           dispatch('fetchUserProfile', user)
           });
           
           }).catch(err => {
             this.commit('setError', err.message);
             this.commit('changeLoading', false);
             console.log(err.message);
           });
         
          
         
           
         },
         async signupBarbeiro({commit},form) {
          // sign user up
          return auth.createUserWithEmailAndPassword(form.email, form.password).then(ref => {
            const user = ref.user;
             // create user profile object in userCollections
            refUsers.doc(user.uid).set({
            name: form.name,
            email: form.email,
            uid: user.uid,
            telefone: form.telefone,
            //padrao lvl 2 (s)
            lvl: '7F2CB9F1C1E54E71000175B5BDD2ADD0'}).then(() => {
            // fetch user profile and set in state
              
                    this._vm.$toasted.global.defaultSuccess("Usuário criado com sucesso!");

                    commit('resetError');
                    commit('changeLoading', false);
                    return true
                  //dispatch('fetchUserProfile', user)
                  });
                  return true
          }).catch(err => {
            this.commit('setError', err.message);
            console.log(err.message);
            this.commit('changeLoading', false);
            return false
          });
       
        },
        
         async fetchUserProfile({ commit }, user) {
           // fetch user profile
           const userProfile = await refUsers.doc(user.uid).get();
           //console.log(userProfile.data());
           // set user profile in state
           commit('setUserProfile', userProfile.data());
           commit('resetError');
           commit('changeLoading', false);

           // Se o usuário caiu no login vindo de uma página protegida, volta
           // para ela; senão mantém o destino padrão de sempre.
           const destino = router.currentRoute && router.currentRoute.query
               ? router.currentRoute.query.redirect
               : null

           const navegacao = destino
               ? router.replace(destino)
               : router.replace({name: 'Agenda'})

           if(navegacao && navegacao.catch){
               navegacao.catch(() => {})
           }
           // change route to dashboard
          // this.$router.replace('home')
         },
         // Repõe o perfil a partir do localStorage. NÃO navega: restaurar sessão
         // não é motivo para tirar o usuário da página em que ele está.
         checkLoggedIn({commit, state}){
            if(promessaRestauracao){
                return promessaRestauracao
            }

            if(state.userProfile){
                return Promise.resolve(state.userProfile)
            }

            promessaRestauracao = new Promise((resolve) => {
                let user = null
                try {
                    user = JSON.parse(window.localStorage.getItem("user"))
                } catch (erro) {
                    user = null
                }

                if(!user || !user.email){
                    resolve(null)
                    return
                }

                refUsers.where("email", "==", user.email).get().then((snap)=>{
                    if(!snap.docs.length){
                        resolve(null)
                        return
                    }

                    let userBuscado = snap.docs[0].data();
                    let idUserEncrypted =  CryptoJS.MD5(userBuscado.uid + new Date().getDate().toString()).toString();

                    // O hash gravado troca a cada dia; se não bater, a sessão expirou.
                    if(user.uid === idUserEncrypted){
                        commit("setUserProfile", userBuscado)
                        console.log("Usuário logado");
                        resolve(userBuscado)
                    }else{
                        resolve(null)
                    }
                }).catch((erro) => {
                    console.log("Não foi possível restaurar a sessão:", erro.message)
                    resolve(null)
                });
            })

            return promessaRestauracao
         },
         recuperarSenha({commit},email){
             //payload é oque eu quiser passar (email)
             console.log(commit);
             
             auth.sendPasswordResetEmail(email).then(()=>{
                this._vm.$toasted.global.defaultSuccess("Email enviado com sucesso!");

             }).catch((err)=>{
                 console.log("erro", err);
             });
         }
       },
     
       getters:{
         
         getCurrentUser(state){
           //return fb.getUser
           return state.userProfile;
         },
         getPermissoes(state){
          return state.permissoes
         },
         isUserAuth(state) {
          
           return state.userProfile != null;
         },
         getLoginError(state){
           return state.loginError;
         },
         getLoadingState(state){
           return state.loading;
         },
         getUserLvl(state){
           return state.userLvl
         },
         userLevel(state){
           
          return state.permissoes[state.userLvl]
         }
       }
}
